require('../../modules/es6.math.log10');
module.exports = require('../../modules/_core').Math.log10;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/math/log10.js
// module id = 159
// module chunks = 0